import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fileUrl = (path) => `${API}/files/${path}`;

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_b77003b8-db30-43c1-a3a7-5d5d8b7b3d54/artifacts/29so36o3_2TSTICKER_TR.webp";

export const HOLO_TEXTURE =
  "https://images.unsplash.com/photo-1603847734787-9e8a3f3e9d60?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
